import {useQuery} from '@apollo/client';
import { GET_PARAMETER_TEMPLATES } from '../../Queries/parameterTemplates';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';

const UseGetAllParameterTemplates = () => {

    const [variables,SetVariables] = useState({
        limit:40,
        offset:0
    });
    const client = useApolloClient();
    const {t} = useTranslation();
    const [content,SetContent] = useState(null);
    const [selectedParameterTemplateIDs,SetSelectedParameterTemplateIDs] = useState([]);

    const {data,loading,error,fetchMore,refetch} = useQuery(GET_PARAMETER_TEMPLATES,{
        variables,
        fetchPolicy:"network-only"
    })

    const FetchMore = (offset) => {

        fetchMore({
            variables: {
                offset: offset
            },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;
                return Object.assign({}, prev, {
                    AllParameterTemplates: [...prev.AllParameterTemplates, ...fetchMoreResult.AllParameterTemplates]
                });
            }
        });
    }

    const GoToPage = (page) => {

        SetVariables((prevValue) => {

            var newOffset = (page - 1) * prevValue.limit;
            if(newOffset == prevValue.offset)
                refetch();

            return {...prevValue,offset:newOffset}

        })
    }

    useEffect(() => {

        if(data)
        {
            const contentData = GetContentData(data.AllParameterTemplates);
            SetContent(contentData);
        }

    },[data])

    const headerData = [
        {
            value: t("ParameterTemplateName"),
            className:"flex-1"
        }
    ];

    const GetContentData = (data) => {

        var contentData = [];

        for(let val of data)
        {
            var cData = {
                data:[
                    {
                        value:val.name,
                        className:"flex-1"
                    }
                ],
            }

            cData.rowID       = val.parameterTemplateID;
            cData.allowEdit   = val.allowEdit;
            cData.allowDelete = val.allowDelete;
            cData.selected    = false;

            contentData.push(cData)
        }
        return contentData;
    }

    const SelectRow = (e,parameterTemplateID) => {

        var checked = e.target.checked;
        var newSelectedParameterTemplateIDs = [...selectedParameterTemplateIDs];
        const newList = SelectParameterTemplateID(content,parameterTemplateID,checked,newSelectedParameterTemplateIDs)

        SetContent(newList);
        SetSelectedParameterTemplateIDs(newSelectedParameterTemplateIDs);
    }

    const SelectAll = (e) => {

        var checked = e.target.checked;
        var newSelectedParameterTemplateIDs = [];
        const newList = SelectParameterTemplateID(content,"all",checked,newSelectedParameterTemplateIDs)

        SetSelectedParameterTemplateIDs(newSelectedParameterTemplateIDs);
        SetContent(newList);
    }

    const SelectParameterTemplateID = (list,parameterTemplateID,checked,selectedParameterTemplateIDs) => {

        const newList = [...list];
        for(let i = 0; i < newList.length; i++)
        {
            if(newList[i].allowDelete == undefined || newList[i].allowDelete == true)
            {
                if(parameterTemplateID == newList[i].rowID || parameterTemplateID === "all")
                {
                    newList[i] = {...newList[i],selected:checked}
                    if(checked)
                        selectedParameterTemplateIDs.push(newList[i].rowID);
                    else
                    {
                        for(let j = 0; j < selectedParameterTemplateIDs.length; j++)
                        {
                            if(selectedParameterTemplateIDs[j] == newList[i].rowID)
                                selectedParameterTemplateIDs.splice(j,1);  
                        } 
                    }
                }

                if(newList[i].subData)
                    newList[i] = {...newList[i],subData:SelectParameterTemplateID(newList[i].subData,parameterTemplateID,checked,selectedParameterTemplateIDs)}
            }
        }

        return newList;
    }

    const UpdateListAfterAddEdit = (selectedParameterTemplateID,data) => {
        
        const { AllParameterTemplates } = client.readQuery({ query: GET_PARAMETER_TEMPLATES, variables });
        var newArray = [...AllParameterTemplates];

        if(selectedParameterTemplateID && selectedParameterTemplateID != 0)
        {
            for(let i in newArray)
            {
                if(newArray[i].parameterTemplateID == data.parameterTemplateID)
                {
                    newArray[i] = {...newArray[i],name: data.name};
                }
            } 
        }
        else
            newArray.unshift({
                parameterTemplateID: data.parameterTemplateID,
                name: data.name,
            })
        
        client.writeQuery({ 
            query:GET_PARAMETER_TEMPLATES,
            variables,
            data:{
                AllParameterTemplates: newArray
            } 
        });
    }

    const UpdateListAfterDelete = (IDs) => {

        var response = IDs.split(",");
        
        const { AllParameterTemplates } = client.readQuery({ query: GET_PARAMETER_TEMPLATES, variables });
        var newArray = [...AllParameterTemplates];
        
        for(let id of response)
        {
            for(let i in newArray)
            {
                if(newArray[i].parameterTemplateID == id)
                    newArray.splice(i,1);
            } 
        } 
        
        client.writeQuery({ 
            query:GET_PARAMETER_TEMPLATES,
            variables,
            data:{
                AllParameterTemplates: newArray
            } 
        });
    }

    return{
        content,
        totalContentLength: data && data.AllParameterTemplatesCount || 0,
        paggingOffset: variables.offset,
        paggingLimit: variables.limit,
        headerData,
        loading,
        error,
        selectedParameterTemplateIDs,
        GoToPage,
        FetchMore,
        SelectRow,
        SelectAll,
        UpdateListAfterAddEdit,
        UpdateListAfterDelete
    }
}

export default UseGetAllParameterTemplates;